import { DESIGN_VARIATION_ATTRIBUTE } from '~/shared/constants'

export const filterDesignVariationToVariableSelections = (
  productOptions: Gallery.ContentQuery.ProductOptions,
  variableOptions: string[],
  categoryIdByTaxonomyId: Record<string, string>,
  numberOfPlaceholders?: string,
  variableAttributes?: string[],
  variableTaxonomyIds?: string[],
): DesignVariations.VariableSelections => {
  const variableSelections = Object.keys(productOptions).reduce((accum, key) => {
    if (variableOptions.includes(key)) {
      return {
        ...accum,
        [key]: productOptions[key],
      }
    }

    return accum
  }, {} as DesignVariations.VariableSelections)

  if (variableAttributes?.includes(DESIGN_VARIATION_ATTRIBUTE.NumberOfPhotos)) {
    variableSelections[DESIGN_VARIATION_ATTRIBUTE.NumberOfPhotos] = numberOfPlaceholders || ''
  }

  const variableTaxonomyIdSelections = Object.keys(categoryIdByTaxonomyId).reduce((accum, key) => {
    if (variableTaxonomyIds?.includes(key)) {
      return {
        ...accum,
        [key]: categoryIdByTaxonomyId[key],
      }
    }

    return accum
  }, {} as DesignVariations.VariableSelections)

  return {
    ...variableSelections,
    ...variableTaxonomyIdSelections,
  }
}
